import { ca } from '@cian/analytics';
import { IJsonQuery } from 'shared/json_query';

const BANNER_NAME = 'Сравнение ЖК';

/**
 * Баннер «Сравнение ЖК» в новостроечной выдаче (флайт сравнения ЖК).
 */
function trackCompareFlightBannerEvent(jsonQuery: IJsonQuery, action: 'show_sopr' | 'click_sopr') {
  ca('eventSite', {
    name: 'oldevent',
    category: 'trap',
    action,
    label: 'newbuilding_compare_jk_promo_banner',
    page: {
      pageType: 'Listing',
      extra: {
        trap_type: 'CompareJKPromo',
        bannerName: BANNER_NAME,
        trapid: BANNER_NAME,
      },
    },
    sc: jsonQuery,
  });
}

export function trackCompareFlightBannerShow(jsonQuery: IJsonQuery) {
  trackCompareFlightBannerEvent(jsonQuery, 'show_sopr');
}

export function trackCompareFlightBannerClick(jsonQuery: IJsonQuery) {
  trackCompareFlightBannerEvent(jsonQuery, 'click_sopr');
}
